import { useState, useEffect, CSSProperties } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { ADMIN_API, PAGINATION_LIMIT } from '../../common/common';
import { getImageUrl, Logout } from '../../common/Funcation';
import { styleObjectBlackButton, getTheme, hexToYIQTextColor } from '../../common/StyleSeter';
import Pagination from '../../components/Pagination'
import Loader from '../../components/Loader'
import { getApi, postApi } from '../../service';
import { usePagination } from '../../hooks/usePagination';
import { dataInterface } from './interface';
import {
  VELKI_GAME_GROUPS,
  VELKI_GROUP_KEYS,
  formatVelkiGameType,
  LiveCatalog,
} from './velkiDashboard';

export const DASHBOARD_WEBSITE_STORAGE_KEY = "selectedDashboardWebsiteId";

const readStoredWebsiteId = () => {
  try {
    return sessionStorage.getItem(DASHBOARD_WEBSITE_STORAGE_KEY) || "";
  } catch {
    return "";
  }
};

function ManageDashboard() {
  const navigate = useNavigate()
  const [searchParams, setSearchParams] = useSearchParams()
  const [pageData, setPageData] = useState<any>({})
  const [totalPages, setTotalPages] = useState(0)
  const [isLoader, setLoader] = useState(false)
  const DD = useSelector((e: any) => e.domainDetails);
  const [isHover, setIsHover] = useState(false);
  const [hoverId, setHoverId] = useState({ isHover: "" });
  const [siteDropDownData, setSiteDropDownData] = useState<any>([]);
  const [webSiteId, setWebSiteIdData] = useState<string>(
    () => searchParams.get("website") || readStoredWebsiteId(),
  );

  const [cloneFromId, setCloneFromId] = useState(
    () => searchParams.get("website") || readStoredWebsiteId(),
  );
  const [cloneToId, setCloneToId] = useState("");
  const [isCloning, setIsCloning] = useState(false);
  const [isReordering, setIsReordering] = useState(false);
  const [dragId, setDragId] = useState<string>("");
  const [dragOverId, setDragOverId] = useState<string>("");
  const [siteTheme, setSiteTheme] = useState("");
  const [groupCounts, setGroupCounts] = useState<Record<string, number>>({});
  const [liveCatalogs, setLiveCatalogs] = useState<LiveCatalog[]>([]);
  const [gameGroup, setGameGroup] = useState<string | null>(() => {
    const value = searchParams.get("group") || "";
    if (!value) return null;
    if (value === "all") return "";
    return VELKI_GROUP_KEYS.includes(value) ? value : null;
  });
  const [catalog, setCatalog] = useState<string | null>(() => {
    const value = searchParams.get("catalog");
    if (!value || value === "all") return value === "all" ? "" : null;
    return value;
  });

  const showAlert = async (id: string) => {
    if (window.confirm("are you sure you wont to delete this item") === true) {
      let data: any = {
        api: ADMIN_API.SETTING.DASHBOARD.DELETE,
        value: {
          id,
        },
      };

      await postApi(data).then(function (response) {
        console.log(response);
        getPageData(1)
      }).catch(err => {
        // debugger
        if (err.response.data.statusCode === 401) {
          Logout()
          navigate('/login')
        }
      })
    };
  }
  const getSiteLabel = (id: string) => {
    const selectedItem = siteDropDownData.find((item: any) => item?._id === id);
    return selectedItem?.title || selectedItem?.domain || "";
  };

  const runClone = async (fromId: string, toId: string) => {
    if (!fromId) {
      alert("Please select a source website first.");
      return;
    }
    if (!toId) {
      alert("Please select a clone website.");
      return;
    }
    if (fromId === toId) {
      alert("Source and clone website must be different.");
      return;
    }

    const fromLabel = getSiteLabel(fromId) || "selected website";
    const toLabel = getSiteLabel(toId) || "clone website";
    if (
      window.confirm(
        `Copy all dashboard images from "${fromLabel}" to "${toLabel}"?`,
      ) === false
    ) {
      setCloneToId("");
      return;
    }

    setIsCloning(true);
    const data: any = {
      api: ADMIN_API.SETTING.DASHBOARD.CLONE,
      value: {
        fromDomain: fromId,
        toDomain: toId,
        cloneToIdTitle: toLabel,
      },
    };

    try {
      const response = await postApi(data);
      const inserted = response?.data?.data?.inserted;
      alert(
        inserted
          ? `Cloned ${inserted} dashboard images to ${toLabel}.`
          : response?.data?.data?.msg || "Cloned successfully!",
      );
      setCloneToId("");
    } catch (err: any) {
      console.error(err);
      if (err.response?.data?.statusCode === 401) {
        Logout();
        navigate("/login");
        return;
      }
      alert(
        err.response?.data?.message ||
          err.response?.data?.data?.msg ||
          "Clone failed. Please try again.",
      );
      setCloneToId("");
    } finally {
      setIsCloning(false);
    }
  };

  const handleCloneToChange = async (e: any) => {
    const selectedId = e.target.value;
    setCloneToId(selectedId);
    if (!selectedId) return;
    await runClone(cloneFromId, selectedId);
  };

  const handleMouseEnter = (id: string = "") => {
    if (id) {
      setHoverId({ isHover: id });
    } else {
      setIsHover(true);
    }
  };

  const handleMouseLeave = (id: string = "") => {
    if (id) {
      setHoverId({ isHover: "" });
    } else {
      setIsHover(false);
    }
  };

  useEffect(() => {
    getSiteDropDownData();
    return () => {};
  }, []);

  const getSiteDropDownData = async () => {
    let data = {
      api: ADMIN_API.SETTING.WEBSITE.GET_DOMAIN,
    };

    await getApi(data)
      .then(function (response) {
        console.log("getSiteDropDownDataData :: ", response);
        const sites = response.data.data || [];
        setSiteDropDownData(sites);

        const storedId = searchParams.get("website") || readStoredWebsiteId();
        const storedExists =
          storedId && sites.some((item: any) => item?._id === storedId);
        if (storedExists) {
          setWebSiteIdData(storedId);
          setCloneFromId(storedId);
          const storedSite = sites.find((item: any) => item?._id === storedId);
          if (storedSite?.theme) {
            setSiteTheme(storedSite.theme === "velki" ? "velki" : "sky-sky");
          }
        } else if (sites.length === 1) {
          persistWebsiteId(sites[0]._id);
        } else if (storedId && !storedExists) {
          persistWebsiteId("");
        }
      })
      .catch((err) => {
        // debugger
        if (err.response.data.statusCode === 401) {
          Logout();
          navigate("/login");
        }
      });
  };

  const persistWebsiteId = (value: string) => {
    const site = siteDropDownData.find((item: any) => item?._id === value);
    const nextTheme = site?.theme === "velki" ? "velki" : site ? "sky-sky" : "";
    setWebSiteIdData(value);
    setCloneFromId(value);
    setCloneToId("");
    setCatalog(null);
    setSiteTheme(nextTheme);
    setGameGroup(nextTheme === "velki" ? "Live" : value ? "" : null);
    try {
      if (value) sessionStorage.setItem(DASHBOARD_WEBSITE_STORAGE_KEY, value);
      else sessionStorage.removeItem(DASHBOARD_WEBSITE_STORAGE_KEY);
    } catch {}
    const params = new URLSearchParams();
    if (value) params.set("website", value);
    if (nextTheme === "velki") params.set("group", "Live");
    setSearchParams(params, { replace: true });
  };

  const getIdForWebSite = (e: any) => {
    persistWebsiteId(e.target.value);
  };

  const isVelki = siteTheme === "velki";
  const canReorder =
    siteTheme === "sky-sky" ||
    (isVelki &&
      Boolean(gameGroup) &&
      (gameGroup !== "Live" || Boolean(catalog)));

  const selectGameGroup = (key: string) => {
    setGameGroup(key);
    const next = new URLSearchParams(searchParams);
    if (webSiteId) next.set("website", webSiteId);
    next.set("group", key || "all");
    if (key !== "Live") next.delete("catalog");
    setSearchParams(next, { replace: true });
  };

  const selectCatalog = (value: string) => {
    setCatalog(value);
    setGameGroup("Live");
    const next = new URLSearchParams(searchParams);
    if (webSiteId) next.set("website", webSiteId);
    next.set("group", "Live");
    if (value) next.set("catalog", value);
    else next.delete("catalog");
    setSearchParams(next, { replace: true });
  };

  const sectionFilter = (): { gameGroup?: string; catalog?: string } | null => {
    if (!isVelki) return {};
    if (!gameGroup) return null;
    if (gameGroup === "Live" && !catalog) return null;
    return {
      gameGroup,
      ...(gameGroup === "Live" ? { catalog: catalog || "" } : {}),
    };
  };

  const getImageSize = (key: string) => {
    switch (key) {
      case "fullSize":
        return "Full Size";
      case "halfWidth":
        return "Half Width";
      case "squareSize":
        return "Square Size";
      default:
        break;
    }
  };

  const getThumbStyle = (widthKey: string): CSSProperties => {
    if (widthKey === "halfWidth") {
      return { width: 72, height: 40 };
    }
    if (widthKey === "squareSize") {
      return { width: 48, height: 48 };
    }
    // fullSize and fallback — wide banner shape
    return { width: 96, height: 40 };
  };

  const goToAddOrEdit = (path: string) => {
    const selectedItem = siteDropDownData.find(
      (item: any) => item?._id === webSiteId,
    );
    navigate(path, {
      state: {
        websiteId: webSiteId,
        websiteTitle: selectedItem?.title || selectedItem?.domain || "",
        websiteTheme: siteTheme,
        gameGroup: isVelki ? gameGroup || "" : "",
        catalog: isVelki && gameGroup === "Live" ? catalog || "" : "",
      },
    });
  };

  const editClick = (e: any) => {
    goToAddOrEdit("/edit-dashboard/" + e._id)
  }

  const handleMove = async (itemId: string, direction: "up" | "down") => {
    if (!webSiteId || isReordering) return;
    const scope = sectionFilter();
    if (scope === null) {
      alert(
        gameGroup === "Live"
          ? "Choose a Live catalog before changing order."
          : "Choose a game type before changing order.",
      );
      return;
    }
    setIsReordering(true);
    try {
      await postApi({
        api: ADMIN_API.SETTING.DASHBOARD.REORDER,
        value: {
          domain: webSiteId,
          id: itemId,
          direction,
          ensureInitialized: true,
          ...scope,
        },
      });
      getPageData(paginationPage || 1);
    } catch (err: any) {
      if (err.response?.data?.statusCode === 401) {
        Logout();
        navigate("/login");
        return;
      }
      alert(err.response?.data?.message || "Could not move item.");
    } finally {
      setIsReordering(false);
    }
  };

  const fetchAllOrderedIds = async () => {
    const scope = sectionFilter();
    const value: any = {
      page: "1",
      limit: "5000",
      domain: webSiteId,
    };
    if (scope && scope.gameGroup) {
      value.gameGroup = scope.gameGroup;
      if (scope.catalog) value.catalog = scope.catalog;
    }
    const response = await postApi({
      api: ADMIN_API.SETTING.DASHBOARD.GET_LIST,
      value,
    });
    return (response?.data?.data?.results || []).map((item: any) =>
      String(item._id),
    );
  };

  const handleDragStart = (e: React.DragEvent, itemId: string) => {
    if (isReordering) {
      e.preventDefault();
      return;
    }
    setDragId(itemId);
    e.dataTransfer.effectAllowed = "move";
    e.dataTransfer.setData("text/plain", itemId);
  };

  const handleDragOver = (e: React.DragEvent, itemId: string) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = "move";
    if (itemId !== dragOverId) setDragOverId(itemId);
  };

  const handleDragEnd = () => {
    setDragId("");
    setDragOverId("");
  };

  const handleDrop = async (e: React.DragEvent, targetId: string) => {
    e.preventDefault();
    const sourceId = dragId || e.dataTransfer.getData("text/plain");
    setDragId("");
    setDragOverId("");
    if (!webSiteId || !sourceId || sourceId === targetId || isReordering) return;
    const scope = sectionFilter();
    if (scope === null) {
      alert(
        gameGroup === "Live"
          ? "Choose a Live catalog before changing order."
          : "Choose a game type before changing order.",
      );
      return;
    }

    setIsReordering(true);
    try {
      const orderedIds: string[] = await fetchAllOrderedIds();
      const fromIndex = orderedIds.indexOf(String(sourceId));
      const toIndex = orderedIds.indexOf(String(targetId));
      if (fromIndex < 0 || toIndex < 0 || fromIndex === toIndex) return;

      orderedIds.splice(fromIndex, 1);
      orderedIds.splice(toIndex, 0, String(sourceId));

      await postApi({
        api: ADMIN_API.SETTING.DASHBOARD.REORDER,
        value: {
          domain: webSiteId,
          orderedIds,
          ensureInitialized: true,
          ...scope,
        },
      });
      getPageData(paginationPage || 1);
    } catch (err: any) {
      if (err.response?.data?.statusCode === 401) {
        Logout();
        navigate("/login");
        return;
      }
      alert(err.response?.data?.message || "Could not reorder by drag.");
    } finally {
      setIsReordering(false);
    }
  };

  const {
    currentPage: paginationPage,
    setCurrent: setPaginationPage,
    visiblePages,
    handlePageClick,
  } = usePagination({
    totalPages: totalPages,
    currentPage: 1,
    onPageChange: (page) => {
      getPageData(page);
      setPaginationPage(page);
    },
  });

  const getPageData = async (
    page: number,
    group: string | null = gameGroup,
    catalogFilter: string | null = catalog,
  ) => {
    setLoader(true)
    const site = siteDropDownData.find((item: any) => item?._id === webSiteId);
    const velki = siteTheme === "velki" || site?.theme === "velki";
    const activeGroup = velki && group ? group : "";
    const activeCatalog =
      velki && activeGroup === "Live" && catalogFilter ? catalogFilter : "";
    const value: any = {
      page: page.toString(),
      limit: PAGINATION_LIMIT.toString(),
      domain: webSiteId,
    };
    if (activeGroup) value.gameGroup = activeGroup;
    if (activeCatalog) value.catalog = activeCatalog;

    let data: dataInterface = {
      api: ADMIN_API.SETTING.DASHBOARD.GET_LIST,
      value,
    };

    await postApi(data).then(function (response) {
      console.log(response);
      const payload = response.data.data || {};
      setPageData(payload)
      setTotalPages(payload?.totalPages || 0)
      if (payload?.theme) {
        setSiteTheme(payload.theme === "velki" ? "velki" : "sky-sky");
      }
      const counts: Record<string, number> = {};
      (payload.groups || []).forEach((groupItem: any) => {
        counts[groupItem.key] = Number(groupItem.count) || 0;
      });
      setGroupCounts(counts);
      setLiveCatalogs(payload.liveCatalogs || []);
    }).catch(err => {
      // debugger
      if (err.response.data.statusCode === 401) {
        Logout()
        navigate('/login')
      }
    }).finally(() => {
      setLoader(false)
    })
  }

  useEffect(() => {
    if (!webSiteId) {
      setPageData({});
      setGroupCounts({});
      setLiveCatalogs([]);
      return;
    }
    const site = siteDropDownData.find((item: any) => item?._id === webSiteId);
    if (!site) return;

    const theme =
      site.theme === "velki" || site.theme === "sky-sky" ? site.theme : siteTheme;

    if (
      (site.theme === "velki" || site.theme === "sky-sky") &&
      siteTheme !== site.theme
    ) {
      setSiteTheme(site.theme);
    }

    if (theme === "sky-sky") {
      if (gameGroup) {
        setGameGroup("");
        return;
      }
    } else if (theme === "velki" && gameGroup === null) {
      setGameGroup("Live");
      return;
    }

    const velki = theme === "velki";
    setPaginationPage(1);
    getPageData(
      1,
      velki ? gameGroup || "" : "",
      velki && gameGroup === "Live" ? catalog || "" : "",
    );
  }, [webSiteId, gameGroup, catalog, siteDropDownData, siteTheme]);

  useEffect(() => {
    if (!isVelki || gameGroup !== "Live" || catalog !== null) return;
    if (!liveCatalogs.length) return;
    const nextCatalog = liveCatalogs[0].key;
    setCatalog(nextCatalog);
    const next = new URLSearchParams(searchParams);
    if (webSiteId) next.set("website", webSiteId);
    next.set("group", "Live");
    next.set("catalog", nextCatalog);
    setSearchParams(next, { replace: true });
  }, [isVelki, gameGroup, catalog, liveCatalogs]);


  const accent = getTheme(DD?.colorSchema)?.backgroundColor || "#212529";
  const accentText = hexToYIQTextColor(accent);
  const totalResults = pageData?.totalResults || pageData?.results?.length || 0;
  const selectedSiteLabel = getSiteLabel(webSiteId);

  const selectStyle: CSSProperties = {
    height: 36,
    minWidth: 180,
    border: "1px solid #d0d5dd",
    borderRadius: 6,
    padding: "0 10px",
    fontSize: 13,
    color: "#344054",
    background: "#fff",
    outline: "none",
  };

  const toolbarLabelStyle: CSSProperties = {
    fontSize: 12,
    fontWeight: 600,
    color: "#667085",
    marginBottom: 4,
    display: "block",
  };

  return (
    <div className="container settings main_wrap" style={{ paddingBottom: 32 }}>
      {isLoader && <Loader />}

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          gap: 16,
          marginTop: 18,
          marginBottom: 16,
          flexWrap: "wrap",
        }}
      >
        <div>
          <h5
            style={{
              margin: 0,
              fontSize: 20,
              fontWeight: 700,
              color: "#101828",
              letterSpacing: "-0.02em",
            }}
          >
            Dashboard Images
          </h5>
          <p style={{ margin: "6px 0 0", fontSize: 13, color: "#667085" }}>
            {isVelki
              ? "Velki shows each game type on its own tab. Set the order inside that tab."
              : "Manage home tiles, platform games, and display order per website."}
            {selectedSiteLabel ? (
              <>
                {" "}
                Selected: <strong style={{ color: "#344054" }}>{selectedSiteLabel}</strong>
                {totalResults > 0 ? ` · ${totalResults} images` : ""}
              </>
            ) : (
              " Select a website to begin."
            )}
          </p>
        </div>
        <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
          {webSiteId && (
            <button
              type="button"
              onClick={() => goToAddOrEdit("/add-dashboard/" + webSiteId)}
              onMouseEnter={() => handleMouseEnter()}
              onMouseLeave={() => handleMouseLeave()}
              style={{
                ...styleObjectBlackButton(DD?.colorSchema, isHover),
                height: 36,
                padding: "0 16px",
                borderRadius: 6,
                fontSize: 13,
                fontWeight: 600,
              }}
              className="btn_black d_flex d_flex_align_center"
            >
              + Add image
            </button>
          )}
        </div>
      </div>

      <div
        style={{
          background: "#fff",
          border: "1px solid #eaecf0",
          borderRadius: 10,
          boxShadow: "0 1px 2px rgba(16,24,40,0.04)",
          padding: "14px 16px",
          marginBottom: 14,
          display: "flex",
          flexWrap: "wrap",
          gap: 16,
          alignItems: "flex-end",
        }}
      >
        <div>
          <label style={toolbarLabelStyle}>Website</label>
          <select
            style={selectStyle}
            name="website"
            id="dashboard-website"
            value={webSiteId}
            disabled={isCloning}
            onChange={getIdForWebSite}
          >
            <option value="">Select website</option>
            {siteDropDownData?.length > 0 &&
              siteDropDownData.map((item: any) => (
                <option key={item?._id} value={item?._id}>
                  {item?.domain}
                </option>
              ))}
          </select>
        </div>

        {cloneFromId && (
          <div>
            <label style={toolbarLabelStyle}>Clone to website</label>
            <select
              style={selectStyle}
              name="cloneTo"
              id="cloneTo"
              value={cloneToId}
              disabled={isCloning}
              onChange={(e) => handleCloneToChange(e)}
            >
              <option value="">
                {isCloning ? "Cloning…" : "Select target website"}
              </option>
              {siteDropDownData?.length > 0 &&
                siteDropDownData.map((item: any) => {
                  if (item?._id === cloneFromId) return null;
                  return (
                    <option key={item?._id} value={item?._id}>
                      {item?.title}
                    </option>
                  );
                })}
            </select>
          </div>
        )}

        <div style={{ marginLeft: "auto", fontSize: 12, color: "#98a2b3", maxWidth: 360 }}>
          {isVelki && !gameGroup
            ? "Pick a game type to change its order."
            : isVelki && gameGroup === "Live" && !catalog
              ? "Live is split by catalog. Pick one to set the order players see in that section."
              : isVelki && gameGroup === "Live"
                ? `Order inside ${catalog === "__none" ? "No catalog" : catalog}.`
                : isVelki && gameGroup
                  ? `Order inside ${gameGroup}.`
                  : <>
                      Drag <strong style={{ color: "#667085" }}>⋮⋮</strong> or use ▲▼ to reorder
                    </>}
        </div>
      </div>

      {isVelki && webSiteId && (
        <div style={{ marginBottom: 14 }}>
          <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
            <button
              type="button"
              onClick={() => selectGameGroup("")}
              style={{
                height: 34,
                padding: "0 12px",
                borderRadius: 999,
                border: !gameGroup ? `1px solid ${accent}` : "1px solid #d0d5dd",
                background: !gameGroup ? accent : "#fff",
                color: !gameGroup ? accentText : "#344054",
                fontWeight: 600,
                fontSize: 13,
                cursor: "pointer",
              }}
            >
              All{" "}
              {Object.keys(groupCounts).length
                ? Object.values(groupCounts).reduce((sum, count) => sum + count, 0)
                : ""}
            </button>
            {VELKI_GAME_GROUPS.map((group) => {
              const active = gameGroup === group.key;
              const count = groupCounts[group.key];
              return (
                <button
                  key={group.key}
                  type="button"
                  onClick={() => selectGameGroup(group.key)}
                  style={{
                    height: 34,
                    padding: "0 12px",
                    borderRadius: 999,
                    border: active ? `1px solid ${accent}` : "1px solid #d0d5dd",
                    background: active ? accent : "#fff",
                    color: active ? accentText : "#344054",
                    fontWeight: 600,
                    fontSize: 13,
                    cursor: "pointer",
                  }}
                >
                  {group.label}
                  {typeof count === "number" ? ` ${count}` : ""}
                </button>
              );
            })}
            {(groupCounts.Other || 0) > 0 && (
              <button
                type="button"
                onClick={() => selectGameGroup("Other")}
                style={{
                  height: 34,
                  padding: "0 12px",
                  borderRadius: 999,
                  border: gameGroup === "Other" ? `1px solid ${accent}` : "1px solid #d0d5dd",
                  background: gameGroup === "Other" ? accent : "#fff",
                  color: gameGroup === "Other" ? accentText : "#344054",
                  fontWeight: 600,
                  fontSize: 13,
                  cursor: "pointer",
                }}
              >
                Other {groupCounts.Other}
              </button>
            )}
          </div>
          {gameGroup === "Live" && (
            <div style={{ display: "flex", flexWrap: "wrap", gap: 8, marginTop: 8 }}>
              <button
                type="button"
                onClick={() => selectCatalog("")}
                style={{
                  height: 30,
                  padding: "0 10px",
                  borderRadius: 6,
                  border: !catalog ? `1px solid ${accent}` : "1px solid #eaecf0",
                  background: !catalog ? `${accent}14` : "#fff",
                  color: "#344054",
                  fontWeight: 600,
                  fontSize: 12,
                  cursor: "pointer",
                }}
              >
                All catalogs
              </button>
              {liveCatalogs.map((item) => {
                const active = catalog === item.key;
                return (
                  <button
                    key={item.key}
                    type="button"
                    onClick={() => selectCatalog(item.key)}
                    style={{
                      height: 30,
                      padding: "0 10px",
                      borderRadius: 6,
                      border: active ? `1px solid ${accent}` : "1px solid #eaecf0",
                      background: active ? `${accent}14` : "#fff",
                      color: "#344054",
                      fontWeight: 600,
                      fontSize: 12,
                      cursor: "pointer",
                    }}
                  >
                    {item.label} {item.count}
                  </button>
                );
              })}
            </div>
          )}
        </div>
      )}

      <div
        style={{
          background: "#fff",
          border: "1px solid #eaecf0",
          borderRadius: 10,
          boxShadow: "0 1px 2px rgba(16,24,40,0.04)",
          overflow: "hidden",
        }}
      >
        <table
          className="table01 margin-table"
          style={{ marginTop: 0, marginBottom: 0, width: "100%" }}
        >
          <thead>
            <tr
              style={{
                background: "#f9fafb",
                borderBottom: "1px solid #eaecf0",
              }}
            >
              <th
                style={{
                  width: 120,
                  textAlign: "center",
                  padding: "12px 8px",
                  fontSize: 11,
                  fontWeight: 700,
                  color: "#667085",
                  textTransform: "uppercase",
                  letterSpacing: "0.04em",
                }}
              >
                Order
              </th>
              <th
                style={{
                  width: "14%",
                  padding: "12px 12px",
                  fontSize: 11,
                  fontWeight: 700,
                  color: "#667085",
                  textTransform: "uppercase",
                  letterSpacing: "0.04em",
                }}
              >
                Image
              </th>
              <th
                style={{
                  padding: "12px 12px",
                  fontSize: 11,
                  fontWeight: 700,
                  color: "#667085",
                  textTransform: "uppercase",
                  letterSpacing: "0.04em",
                }}
              >
                Title
              </th>
              {isVelki && (
                <th
                  style={{
                    padding: "12px 12px",
                    fontSize: 11,
                    fontWeight: 700,
                    color: "#667085",
                    textTransform: "uppercase",
                    letterSpacing: "0.04em",
                  }}
                >
                  Game type
                </th>
              )}
              {isVelki && (
                <th
                  style={{
                    padding: "12px 12px",
                    fontSize: 11,
                    fontWeight: 700,
                    color: "#667085",
                    textTransform: "uppercase",
                    letterSpacing: "0.04em",
                  }}
                >
                  Catalog
                </th>
              )}
              <th
                style={{
                  padding: "12px 12px",
                  fontSize: 11,
                  fontWeight: 700,
                  color: "#667085",
                  textTransform: "uppercase",
                  letterSpacing: "0.04em",
                }}
              >
                Platform
              </th>
              <th
                style={{
                  padding: "12px 12px",
                  fontSize: 11,
                  fontWeight: 700,
                  color: "#667085",
                  textTransform: "uppercase",
                  letterSpacing: "0.04em",
                }}
              >
                Link
              </th>
              <th
                style={{
                  width: "11%",
                  padding: "12px 12px",
                  fontSize: 11,
                  fontWeight: 700,
                  color: "#667085",
                  textTransform: "uppercase",
                  letterSpacing: "0.04em",
                }}
              >
                Size
              </th>
              <th
                style={{
                  width: "12%",
                  padding: "12px 12px",
                  fontSize: 11,
                  fontWeight: 700,
                  color: "#667085",
                  textTransform: "uppercase",
                  letterSpacing: "0.04em",
                }}
              >
                Action
              </th>
            </tr>
          </thead>
          <tbody id="matches-table">
            {pageData.results && pageData.results?.length > 0 ? (
              pageData.results.map((item: any, i: number) => {
                const sectionIndex = (paginationPage - 1) * PAGINATION_LIMIT + i;
                const isFirst = sectionIndex === 0;
                const isLast = totalResults > 0 && sectionIndex >= totalResults - 1;
                return (
                <tr
                  key={item?._id || i}
                  onDragOver={(e) => {
                    if (!canReorder) return;
                    handleDragOver(e, item._id);
                  }}
                  onDragLeave={() => {
                    if (dragOverId === item._id) setDragOverId("");
                  }}
                  onDrop={(e) => handleDrop(e, item._id)}
                  style={{
                    borderBottom: "1px solid #f2f4f7",
                    background:
                      dragOverId === item._id && dragId && dragId !== item._id
                        ? "#eff8ff"
                        : dragId === item._id
                          ? "#f9fafb"
                          : i % 2 === 1
                            ? "#fcfcfd"
                            : "#fff",
                    opacity: dragId === item._id ? 0.7 : 1,
                    transition: "background 0.15s ease",
                  }}
                >
                  <td
                    style={{
                      padding: "10px 6px",
                      verticalAlign: "middle",
                      textAlign: "center",
                    }}
                  >
                    <div
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: 6,
                      }}
                    >
                      <span
                        draggable={canReorder && !isReordering}
                        onDragStart={(e) => handleDragStart(e, item._id)}
                        onDragEnd={handleDragEnd}
                        style={{
                          cursor: !canReorder || isReordering ? "not-allowed" : "grab",
                          userSelect: "none",
                          color: canReorder ? "#98a2b3" : "#eaecf0",
                          fontSize: 15,
                          lineHeight: 1,
                          width: 16,
                          textAlign: "center",
                        }}
                        title={canReorder ? "Drag to reorder" : "Choose a section to reorder"}
                      >
                        ⋮⋮
                      </span>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: 2,
                        }}
                      >
                        <button
                          type="button"
                          title="Move up"
                          disabled={!canReorder || isReordering || isFirst}
                          onClick={() => handleMove(item._id, "up")}
                          style={{
                            width: 22,
                            height: 18,
                            padding: 0,
                            lineHeight: "16px",
                            fontSize: 10,
                            border: "1px solid #d0d5dd",
                            borderRadius: 4,
                            background: "#fff",
                            color: "#475467",
                            cursor: isReordering ? "not-allowed" : "pointer",
                          }}
                        >
                          ▲
                        </button>
                        <button
                          type="button"
                          title="Move down"
                          disabled={!canReorder || isReordering || isLast}
                          onClick={() => handleMove(item._id, "down")}
                          style={{
                            width: 22,
                            height: 18,
                            padding: 0,
                            lineHeight: "16px",
                            fontSize: 10,
                            border: "1px solid #d0d5dd",
                            borderRadius: 4,
                            background: "#fff",
                            color: "#475467",
                            cursor: isReordering ? "not-allowed" : "pointer",
                          }}
                        >
                          ▼
                        </button>
                      </div>
                      <span
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                          minWidth: 28,
                          height: 28,
                          padding: "0 6px",
                          fontSize: 12,
                          fontWeight: 700,
                          color: accentText === "#FFF" ? accent : "#344054",
                          background: accentText === "#FFF" ? `${accent}14` : "#f2f4f7",
                          borderRadius: 6,
                          border: `1px solid ${accentText === "#FFF" ? `${accent}33` : "#eaecf0"}`,
                        }}
                      >
                        {isVelki && canReorder ? sectionIndex + 1 : item.sort ?? "-"}
                      </span>
                    </div>
                  </td>

                  <td style={{ padding: "10px 12px", verticalAlign: "middle" }}>
                    <a
                      href={getImageUrl(item.image)}
                      target="_blank"
                      rel="noreferrer"
                      style={{ display: "inline-block" }}
                      title={getImageSize(item.Width) || "Image"}
                    >
                      <span
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                          minWidth: 96,
                          minHeight: 52,
                        }}
                      >
                        <img
                          src={getImageUrl(item.image)}
                          alt={item.title}
                          style={{
                            ...getThumbStyle(item.Width),
                            objectFit: "cover",
                            borderRadius: 8,
                            border: "1px solid #eaecf0",
                            background: "#f9fafb",
                            display: "block",
                            boxShadow: "0 1px 2px rgba(16,24,40,0.06)",
                          }}
                        />
                      </span>
                    </a>
                  </td>

                  <td
                    style={{
                      padding: "10px 12px",
                      verticalAlign: "middle",
                      fontWeight: 600,
                      color: "#101828",
                      fontSize: 13,
                    }}
                  >
                    {item.title}
                    {item.gameCode ? (
                      <div
                        style={{
                          marginTop: 2,
                          fontSize: 11,
                          fontWeight: 500,
                          color: "#98a2b3",
                        }}
                      >
                        {item.gameCode}
                      </div>
                    ) : null}
                  </td>

                  {isVelki && (
                    <td style={{ padding: "10px 12px", verticalAlign: "middle", fontSize: 12, color: "#344054" }}>
                      {formatVelkiGameType(item.gameType)}
                    </td>
                  )}
                  {isVelki && (
                    <td style={{ padding: "10px 12px", verticalAlign: "middle", fontSize: 12, color: "#344054" }}>
                      {item.catalog || "—"}
                    </td>
                  )}

                  <td style={{ padding: "10px 12px", verticalAlign: "middle" }}>
                    {item.platform ? (
                      <span
                        style={{
                          display: "inline-block",
                          padding: "3px 8px",
                          borderRadius: 999,
                          fontSize: 11,
                          fontWeight: 600,
                          background: "#f2f4f7",
                          color: "#344054",
                          border: "1px solid #eaecf0",
                        }}
                      >
                        {item.platform}
                      </span>
                    ) : (
                      <span style={{ color: "#d0d5dd" }}>—</span>
                    )}
                  </td>

                  <td
                    style={{
                      padding: "10px 12px",
                      verticalAlign: "middle",
                      fontSize: 12,
                      color: "#667085",
                      maxWidth: 180,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                    title={item.link}
                  >
                    {item.link || "—"}
                  </td>

                  <td style={{ padding: "10px 12px", verticalAlign: "middle" }}>
                    <span
                      style={{
                        display: "inline-block",
                        padding: "3px 10px",
                        borderRadius: 999,
                        fontSize: 11,
                        fontWeight: 600,
                        background:
                          item.Width === "fullSize"
                            ? "#eff8ff"
                            : item.Width === "halfWidth"
                              ? "#fffaeb"
                              : "#f4f3ff",
                        color:
                          item.Width === "fullSize"
                            ? "#175cd3"
                            : item.Width === "halfWidth"
                              ? "#b54708"
                              : "#5925dc",
                        border:
                          item.Width === "fullSize"
                            ? "1px solid #b2ddff"
                            : item.Width === "halfWidth"
                              ? "1px solid #fedf89"
                              : "1px solid #d9d6fe",
                      }}
                    >
                      {getImageSize(item.Width)}
                    </span>
                  </td>

                  <td style={{ padding: "10px 12px", verticalAlign: "middle" }}>
                    <div style={{ display: "flex", gap: 6 }}>
                      <button
                        onClick={() => editClick(item)}
                        onMouseEnter={() => handleMouseEnter(item._id)}
                        onMouseLeave={() => handleMouseLeave(item._id)}
                        style={{
                          ...styleObjectBlackButton(
                            DD?.colorSchema,
                            hoverId.isHover === item._id,
                          ),
                          height: 30,
                          padding: "0 12px",
                          borderRadius: 6,
                          fontSize: 12,
                          fontWeight: 600,
                        }}
                        className="btn_black"
                      >
                        Edit
                      </button>
                      <button
                        type="button"
                        onClick={() => showAlert(item._id)}
                        style={{
                          height: 30,
                          width: 30,
                          padding: 0,
                          borderRadius: 6,
                          border: "1px solid #fda29b",
                          background: "#fef3f2",
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                          cursor: "pointer",
                        }}
                        title="Delete"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 448 512"
                          style={{ width: 11 }}
                        >
                          <path
                            fill="#d92d20"
                            d="M135.2 17.7C140.6 6.8 151.7 0 163.8 0H284.2c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32h96l7.2-14.3zM32 128H416V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V128zm96 64c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16z"
                          />
                        </svg>
                      </button>
                    </div>
                  </td>
                </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={isVelki ? 9 : 7} style={{ padding: "56px 24px", textAlign: "center" }}>
                  <div
                    style={{
                      fontSize: 15,
                      fontWeight: 600,
                      color: "#344054",
                      marginBottom: 6,
                    }}
                  >
                    {webSiteId
                      ? isVelki && gameGroup
                        ? `No images in ${gameGroup}${
                            gameGroup === "Live" && catalog
                              ? ` / ${catalog === "__none" ? "No catalog" : catalog}`
                              : ""
                          }`
                        : "No dashboard images yet"
                      : "No website selected"}
                  </div>
                  <div style={{ fontSize: 13, color: "#98a2b3" }}>
                    {webSiteId
                      ? "Click “Add image” to create the first tile for this site."
                      : "Choose a website above to view and manage its images."}
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <div
        className="d_flex d_flex_align_center w_100 d_flex_justify_center"
        style={{ marginTop: 16 }}
      >
        {totalPages > 0 ? (
          Pagination && (
            <Pagination
              handlePageClick={handlePageClick}
              totalPages={totalPages}
              currentPage={paginationPage}
              visiblePages={visiblePages}
            />
          )
        ) : (
          ""
        )}
      </div>
    </div>
  );
}

export default ManageDashboard;
